import { AboutMenu, Category } from "@hermes/api-model-menu";

import { MenuLink } from "../model/menu.model";

export const extractLinksFromMenuEntries = (
    menuEntryList: Category[] | undefined,
    menuLinks: MenuLink[] = [],
): MenuLink[] => {
    if (menuEntryList) {
        menuEntryList.forEach((menuEntry) => {
            extractLinksFromMenuEntries(menuEntry.subcategories, menuLinks);

            if (menuEntry.categoryPath) {
                menuLinks.push({
                    path: menuEntry.categoryPath,
                    label: cleanMenuEntryName(menuEntry.name, false),
                });
            }
        });
    }

    return menuLinks;
};

export const extractLinksFromAboutEntries = (
    menuEntryList: AboutMenu[] | undefined,
    menuLinks: MenuLink[] = [],
): MenuLink[] => {
    if (menuEntryList) {
        menuEntryList.forEach((menuEntry) => {
            extractLinksFromAboutEntries(menuEntry.items, menuLinks);

            if (menuEntry.data) {
                menuLinks.push({
                    path: menuEntry.data,
                    label: cleanMenuEntryName(menuEntry.label, false),
                });
            }
        });
    }

    return menuLinks;
};

/**
 * Level 1 menu entry can have &nbsp; or <wbr> in name to be well displayed
 * on horizontal menu, on the majority of occasion we want the name to be clean
 * @param input - The raw menu entry name (may contain HTML entities or special characters).
 * @param shouldSanitizeForAccessibility - If true, applies additional cleaning for accessibility:
 */
export const cleanMenuEntryName = (
    input: string,
    shouldSanitizeForAccessibility: boolean,
) => {
    if (shouldSanitizeForAccessibility) {
        /*
        Replaces HTML entities and commas with spaces,
        Remove all apostrophes,
        Removes accents,
        Converts to lowercase,
        Replaces multiple spaces with hyphens,
        Trims hyphens from start/end.
        */
        return input
            .replace(/&nbsp;|<wbr>|,/g, " ")
            .replace(/['\u02BC\u2018\u2019\u201B]/g, "-")
            .normalize("NFD")
            .replace(/[\u0300-\u036F]/g, "")
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/^-+|-+$/g, "");
    }
    // Basic cleaning: only removes non-breaking space and word break HTML entities
    return input.replace(/&nbsp;/g, " ").replace(/<wbr>/g, "");
};
